import React from 'react'
import { TableCell, TableRow } from 'transfix-ui'
import { TABLE_COLUMNS_COUNT } from '../constants'

const ShipperTableRowEmpty = () => (
  <TableRow>
    <TableCell dataTest='shipper-empty-row' colSpan={TABLE_COLUMNS_COUNT}>
      There is no data to be shown.
    </TableCell>
  </TableRow>
)

export default ShipperTableRowEmpty
